var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _c("div", { staticClass: "preloader" }, [
      _c("div", { staticClass: "img" }, [
        _c("svg", { staticClass: "filter", attrs: { version: "1.1" } }, [
          _c("defs", [
            _c(
              "filter",
              { attrs: { id: "gooeyness" } },
              [
                _c("feGaussianBlur", {
                  attrs: {
                    in: "SourceGraphic",
                    stdDeviation: "10",
                    result: "blur"
                  }
                }),
                _vm._v(" "),
                _c("feColorMatrix", {
                  attrs: {
                    in: "blur",
                    mode: "matrix",
                    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 20 -10",
                    result: "gooeyness"
                  }
                }),
                _vm._v(" "),
                _c("feComposite", {
                  attrs: {
                    in: "SourceGraphic",
                    in2: "gooeyness",
                    operator: "atop"
                  }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "dots" }, [
          _c("div", { staticClass: "dot mainDot" }),
          _vm._v(" "),
          _c("div", { staticClass: "dot" }),
          _vm._v(" "),
          _c("div", { staticClass: "dot" }),
          _vm._v(" "),
          _c("div", { staticClass: "dot" }),
          _vm._v(" "),
          _c("div", { staticClass: "dot" })
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }